import { FC } from "react";

import {
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

interface IMiscSetupFieldsPanel {
	selectedProvinceName: string | null;
}
export const MiscSetupFieldsPanel: FC<IMiscSetupFieldsPanel> = ({
	selectedProvinceName,
}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				label="Maximum Value of RRSP"
				id="maximumValueOfRrsp"
				testId={`Maximum-Value-of-RRSP`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label={`CPI ${
					selectedProvinceName && selectedProvinceName !== null
						? selectedProvinceName
						: "Provincial"
				}`}
				id="cpiProvincial"
				testId={`cpi-Provincial`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="CPI Federal"
				id="cpiFederal"
				testId={`CPI-Federal`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			{/* <RHookFormTextFieldWithLabel
				label="Dead to file T4 for currently selected year of operation"
				id="deadToFileT4ForCurrentlySelectedYearOfOperation"
				testId={`Dead-to-file-T4-for-currently-selected-year-of-operation`}
				labelPosition={LabelPosition.Top}
			/> */}
			<RHookFormDatePicker
				label="Deadline to file T4 for currently selected year of operation"
				name="deadToFileT4ForCurrentlySelectedYearOfOperation"
				testId={`maximum`}
				format="M dd, yy"
				labelPosition={LabelPosition.Top}
				
			/>
			<RHookFormNumberFieldWithLabel
				id={"amountForFederalCanadaEmploymentCreditK4"}
				label="Amount for Federal Canada Employment Credit K4"
				testId="Amount-for-Federal-Canada-Employment-Credit-K4"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"amountForProvincialEmploymentCreditK4"}
				label="Amount for Provincial Employment Credit K4"
				testId="Amount-for-Provincial-Employment-Credit-K4"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
